import React, { useState, FC } from 'react';
import Input from 'b2b-ui-components-lib/lib/components/input';
import RadioGroup from 'b2b-ui-components-lib/lib/components/radioGroup';
import { numberWithCommas, getCurrentServiceType } from 'common/utils/app.utils';
import ServicesDropdown from 'dedicated/components/choose-plan/servicesDropdown/servicesDropdown';

import { SERVICE_TYPE, SERVICE_TYPE_LIST, HARDWARE_TYPE } from 'home/view/manage-feasibility/constants';
import { DEDICATED_COMMON_PARAMS } from 'common/constants/app.constants';

import 'dedicated/components/choose-plan/planConfigrationModal.scss';
import './CircuitDetail.scss';

const HARDWARE_TYPE_LIST = [
  { id: HARDWARE_TYPE.STANDARD, displayName: 'Standard Hardware' },
  { id: HARDWARE_TYPE.NON_STANDARD, displayName: 'Non-Standard Hardware* (additional charges may apply) ' }
];

interface Props {
  isOpen: boolean;
  onClose: (data: boolean) => void;
  circuitModalDataSet: any;
}

const CircuitDetail: FC<Props> = ({ isOpen, onClose, circuitModalDataSet }) => {
  const productType = DEDICATED_COMMON_PARAMS.serviceType;

  const [showServiceTypeTooltipInfo, setShowServiceTypeTooltipInfo] = useState<boolean>(false);

  const getServiceTypeList = () => {
    if (productType === 'DEDICATED_INTERNET') {
      return SERVICE_TYPE_LIST.filter((item: any) => item?.id !== SERVICE_TYPE.PARTIALLY_MANAGED.id);
    }

    return SERVICE_TYPE_LIST;
  };

  const {
    circuitId,
    companyName,
    installationAddress: { addressLine1, state, country } = {
      addressLine1: '',
      state: '',
      country: ''
    },
    currentBandwidth,
    currentMediaType,
    currentServiceType,
    currentArc,
    requestedBandwidth,
    requestedServiceType,
    requestedHardwareType,
    requestedRouterMake,
    requestedRouterModel
  } = circuitModalDataSet;

  const installationAddressEle = addressLine1 ? `${addressLine1} ${state ? `, ${state}` : ''} ${country ? `, ${country}` : ''}` : '-';
  const selectedServiceType = getServiceTypeList().find((item) => item?.id === requestedServiceType);
  const selectedHardwareType = HARDWARE_TYPE_LIST.find((item) => item?.id === requestedHardwareType);
  const isSelectedHardwareNonStandard = selectedHardwareType?.id === HARDWARE_TYPE.NON_STANDARD;

  const getRequestedBandwidthValue = () => {
    if (requestedBandwidth?.includes('Mbps')) {
      return `${requestedBandwidth}`;
    }

    return `${requestedBandwidth} Mbps`;
  };

  return (
    <React.Fragment>
      {isOpen && (
        <div className={`drawer_container ${isOpen ? 'active' : ''}`}>
          <div className="drawer">
            <div className="drawer_header">
              <div className="container">
                <div className="drawer_head">
                  <div className="title_info">
                    <h4 className="title_heading">
                      Circuit ID: {circuitId} {isSelectedHardwareNonStandard ? `| Non-Standard Attribute*` : ''}
                    </h4>
                  </div>
                  <span className="close_icon" onClick={() => onClose(false)}></span>
                </div>
              </div>
            </div>
            <div className="drawer_body circuitModal-drawer-body">
              <div className="scroll_content">
                <div className="container">
                  {isSelectedHardwareNonStandard && (
                    <div className="config_info">
                      <div className="info_title">
                        <h5>
                          <span className="color-red">* Please note that the Pricing of the non-standard attributes will be under review with the key account manager.</span>
                        </h5>
                      </div>
                    </div>
                  )}
                  <div className="config_form">
                    <div className="select_info">
                      <div className="text">Site Details </div>
                    </div>

                    <div className="row">
                      <div className="flg-lg-6 flg-md-6">
                        <Input label="Circuit ID" value={circuitId} disabled={true} required />
                      </div>
                      <div className="flg-lg-6 flg-md-6">
                        <Input label="Company Name" value={companyName} disabled={true} required />
                      </div>
                    </div>

                    <div className="row">
                      <div className="flg-lg-12 flg-md-12">
                        <Input label="Installation Address" value={installationAddressEle} disabled={true} required />
                      </div>
                    </div>

                    <div className="row">
                      <div className="flg-lg-6 flg-md-6">
                        <Input label="Current Bandwidth" value={currentBandwidth} disabled={true} required />
                      </div>
                      <div className="flg-lg-6 flg-md-6">
                        <Input label="Current Media Type" value={currentMediaType} disabled={true} required />
                      </div>
                    </div>

                    <div className="row">
                      <div className="flg-lg-6 flg-md-6">
                        <Input label="Current Service Type" value={getCurrentServiceType(currentServiceType)} disabled={true} required />
                      </div>
                      <div className="flg-lg-6 flg-md-6">
                        <Input label="Current Annual Recurring Charge" value={`₹ ${numberWithCommas(currentArc)}`} disabled={true} required />
                      </div>
                    </div>

                    <div className="select_info">
                      <div className="text">Requested Bandwidth</div>
                    </div>

                    <div className="row">
                      <div className="flg-lg-6 flg-md-6">
                        <Input label="Requested Bandwidth" value={getRequestedBandwidthValue()} disabled={true} required />
                      </div>
                    </div>

                    <div className="select_info">
                      <div className="text">Requested Service Type </div>
                      {/* {
                                                    primaryForm.serviceType.value.id === 'MANAGED' && */}
                      <div className="tooltip_wrap">
                        <span
                          className="material-icons-outlined"
                          onMouseOver={() => setShowServiceTypeTooltipInfo(true)}
                          onClick={() => setShowServiceTypeTooltipInfo(!showServiceTypeTooltipInfo)}
                        >
                          info
                        </span>
                        {showServiceTypeTooltipInfo && <ServicesDropdown setShowManageServices={setShowServiceTypeTooltipInfo} />}
                      </div>
                      {/* } */}
                    </div>

                    <div className="radio_box">
                      <RadioGroup options={getServiceTypeList()} value={selectedServiceType} disabled={true} />
                    </div>

                    <div className="select_info">
                      <div className="text">Type of hardware </div>
                    </div>

                    <div className="radio_box">
                      <RadioGroup options={HARDWARE_TYPE_LIST} value={selectedHardwareType} disabled={true} />
                    </div>

                    <div className="row">
                      <div className="flg-lg-8 flg-md-8">
                        <Input label="Hardware Type or Common Platform Enumeration (CPE) Type" value={requestedRouterMake} disabled={true} required />
                      </div>
                      <div className="flg-lg-4 flg-md-4">
                        <Input label="Hardware (CPE) Specification" value={requestedRouterModel} disabled={true} required />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default CircuitDetail;
